// extracted by mini-css-extract-plugin
export var wrapper = "nav-items-module--wrapper--IpGi+";
export var item = "nav-items-module--item--5T37T";